// Asks the learner gateway for the classrooms and learners a tablet can be set
// up for, and for a one-time setup code. The teacher is proved by their own
// short-lived Directus access token, held in memory by the SDK; nothing is
// stored. The code itself arrives only inside the QR picture.

import { GATEWAY_URL, IS_PREVIEW } from "../config";
import directus from "./directusClient";

export class TabletSetupError extends Error {
  constructor(status, reason) {
    super(reason || `gateway answered ${status}`);
    this.response = { status };
    this.reason = reason || null;
  }
}

export const isTabletSetupAvailable = () => !IS_PREVIEW && Boolean(GATEWAY_URL);

const call = async (path, { method = "GET", json } = {}) => {
  const token = await directus.getToken();
  if (!token) throw new TabletSetupError(401, "not-signed-in");
  const response = await fetch(`${GATEWAY_URL}${path}`, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(json !== undefined ? { "Content-Type": "application/json" } : {}),
    },
    body: json !== undefined ? JSON.stringify(json) : undefined,
  });
  const data = await response.json().catch(() => null);
  if (!response.ok) throw new TabletSetupError(response.status, data?.reason);
  return data;
};

// [{ id, name, learners: [{ id, name }] }]
export const readClassrooms = async () => (await call("/teacher/learners")).classrooms;

// { learnerName, qrSvg, expiresAt }
export const createSetupCode = ({ classroomId, learnerId }) =>
  call("/teacher/setup-codes", { method: "POST", json: { classroomId, learnerId } });
